import { useState } from "react";// adjust import path
import { Service } from "../Service/ApiService";

export const useZipcodeValidation = (
  setFormData: React.Dispatch<React.SetStateAction<any>>,
  setErrors: React.Dispatch<React.SetStateAction<any>>
) => {
  const [zipcodeLoading, setZipcodeLoading] = useState(false);
  const [validZipcode, setValidZipcode] = useState(false);

  const validatePostalCode = async (zipcode: string): Promise<boolean> => {
    setZipcodeLoading(true);
    try {
      let trimmedZip = zipcode.trim().toUpperCase();
      let originalZipcode = trimmedZip;

      if (trimmedZip.length < 3) {
        setFormData((prev: any) => ({ ...prev, city: "", state: "", zipcode }));
        setErrors((prev: any) => ({ ...prev, zipcode: "Please enter valid zipcode" }));
        setValidZipcode(false);
        return false;
      }

      const caZipRegex = /^[A-Z]\d[A-Z]\s?\d[A-Z]\d$/;
      let isCA = false;

      if (caZipRegex.test(trimmedZip)) {
        isCA = true;
        if (trimmedZip.length === 6 || trimmedZip.length === 7) {
          trimmedZip = trimmedZip.replace(/\s+/g, "").substring(0, 3).toUpperCase();
        } else {
          setFormData((prev: any) => ({ ...prev, city: "", state: "", zipcode }));
          setErrors((prev: any) => ({ ...prev, zipcode: "Please enter valid zipcode" }));
          setValidZipcode(false);
          return false;
        }
      }

      const response = await Service.getCityAndState(trimmedZip, isCA ? "ca" : "us");
      const { city, state } = response.data.zipCode || {};

      if (city && state) {
        setFormData((prev: any) => ({ ...prev, city, state, zipcode: originalZipcode }));
        setErrors((prev: any) => ({ ...prev, zipcode: "" }));
        setValidZipcode(true);
        return true;
      } else {
        setFormData((prev: any) => ({ ...prev, city: "", state: "", zipcode: trimmedZip }));
        setErrors((prev: any) => ({ ...prev, zipcode: "Please enter valid zipcode" }));
        setValidZipcode(false);
        return false;
      }
    } catch (error) {
      setFormData((prev: any) => ({ ...prev, city: "", state: "", zipcode }));
      setErrors((prev: any) => ({ ...prev, zipcode: "Please enter valid zipcode" }));
      setValidZipcode(false);
      return false;
    } finally {
      setZipcodeLoading(false);
    }
  };

  return { zipcodeLoading, validZipcode, validatePostalCode };
};